import createHistory from 'history/createBrowserHistory';

const timeout = 500;
const historyExitingEventType = 'history/exiting';

const getUserConfirmation = (pathname, callback) => {
  const event = new CustomEvent(historyExitingEventType, { detail: { pathname } });
  window.dispatchEvent(event);
  setTimeout(() => {
    callback(true);
  }, timeout);
};

let history;
if (typeof document !== 'undefined') {
  history = createHistory({ getUserConfirmation });
  history.block(location => location.pathname);
}

export const replaceHistory = () => history;
export { historyExitingEventType, timeout };

/* eslint global-require: off */
exports.onClientEntry = () => {
  require('core-js/features/array/from');
  require('core-js/features/dom-collections/for-each');
};



// WEBPACK FOOTER //
// ./gatsby-browser.js